import { Persona } from '@sdk/personaCollection/types/Persona';
import { getFormattedGroups } from '@sdk/personaCollection/utils/personaCollection.utils';

import { formatEmployeeCountAppendix } from '@web/common/utils/i18n';

const GROUP_TITLE_CHARACTER_LIMIT = 23;

export default function getMentionSubtitle(persona: Persona): string {
  if (persona.type === 'user') {
    const locationTitle = getFormattedGroups(persona.locations, {
      maxLength: GROUP_TITLE_CHARACTER_LIMIT,
    });

    const positionTitle = getFormattedGroups(persona.positions, {
      maxLength: GROUP_TITLE_CHARACTER_LIMIT,
    });

    let text = locationTitle;
    if (positionTitle) {
      text += text ? ` • ${positionTitle}` : positionTitle;
    }

    return text;
  }

  return formatEmployeeCountAppendix(persona.memberCount);
}
